// extracted by mini-css-extract-plugin
export var label = "_ib-2";
export var slideContainer = "_ib-0";
export var slider = "_ib-1";